export default {
  isDashboardsLoading: (state) => state.dashboardsStatus === 'loading',
  isOrganizationsLoading: (state) => state.organizationsStatus === 'loading',
  isOrganizationUsersLoading: (state) => state.organizationUsersStatus === 'loading',
  // Solo cuando se sabe: sin respuesta del backend no se afirma que la fuente esté inactiva.
  isSourceInactive: (state) => state.sourceStatus !== null && !state.sourceStatus.isActive
}
